import React from 'react';

const AuthorizationPdfPreviewModal = ({ visible, onClose, pdfUrl }) => {
    if (!visible) return null;

    return (
        <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center">
            <div className="bg-white w-[90%] h-[90%] rounded-xl shadow-xl flex flex-col">
                {/* header */}
                <div className="flex items-center justify-between px-4 py-3 border-b">
                    <h3 className="font-semibold">Aperçu de l’autorisation</h3>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-black"
                    >
                        ✕
                    </button>
                </div>

                {/* PDF */}
                <div className="flex-1">
                    {pdfUrl ? (
                        <iframe
                            src={pdfUrl}
                            title="Authorization PDF"
                            className="w-full h-full"
                        />
                    ) : (
                        <div className="flex items-center justify-center h-full text-gray-500">
                            Impossible de charger le PDF
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AuthorizationPdfPreviewModal;
